// Sets the background color of the product label type badge
const getServiceBadgeColor = (product) => {
    return product.productLabel ? (product.productLabel.toLowerCase() === "novo serviço" ? "yellowBadge"
            : product.productLabel.toLowerCase() === "menor preço" ? "greenBadge"
                : "redBadge"
    ) : "";
}

export default getServiceBadgeColor;
